import { strLang } from "../../functions/strLang";

export default function RecordTotal({ data }) {
  const { status, extraDates, ter, done, total, terDone, terTotal } = data;

  return (
    ter && (
      <div>
        {status === 3 && !extraDates
          ? `${strLang("addresses")}: ${
              terDone > 0 ? terDone + " / " : ""
            }${terTotal}`
          : `${
              done > 0 || total > 0
                ? `${strLang("record")}: ${done} / ${total}`
                : ""
            }`}
      </div>
    )
  );
}
